export enum PageType {
  APPLIED = "applied",
  EXPLORE = "explore",
  SIGN_IN = "sign_in",
}
